export const MERKLE_HASH_VERSIONS = {
    ONE: 1,
    TWO: 2,
};
//# sourceMappingURL=constants.js.map